// extracted by mini-css-extract-plugin
module.exports = {"section-gap":"styles_section-gap__IhOx_","row-image":"styles_row-image__pQ7Z3","crm-database-image":"styles_crm-database-image__ryCaE"};